import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'MANUAL DE GESTIÓN DEL SOBREPENSAMIENTO',
  subtitle: 'BUCLE MENTAL',
  items: ['Protocolos para conversaciones, mensajes, decisiones y anticipación', 'Respuestas y árboles de decisión para cortar pensamientos repetitivos', 'Criterios claros para saber cuándo pensar y cuándo cerrar'],
  result: '“Dejo de darle vueltas y vuelvo a lo que puedo hacer ahora.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'GUÍA DE DESCARGA Y PROCESAMIENTO EMOCIONAL',
  subtitle: 'DESCARGA EMOCIONAL',
  items: ['Respuestas para situaciones que terminaron pero todavía pesan', 'Guías para reparar, aprender, aceptar o cerrar', 'Pasos concretos para dejar de cargar lo que ya no avanza'],
  result: '“Sé qué hacer con esto sin seguir cargándolo todo el día.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'MANUAL DE GESTIÓN DE LA EXIGENCIA INTERNA',
  subtitle: 'EXIGENCIA INTERNA',
  items: ['Respuestas listas para culpa, autocrítica y perfeccionismo', 'Reencuadres para errores, comparación y exigencia excesiva', 'Formas realistas de responderte sin castigarte de más'],
  result: '“Puedo corregir lo necesario sin seguir castigándome mentalmente.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: 'GUÍA PRÁCTICA DE LÍMITES Y GESTIÓN VINCULAR',
  subtitle: 'LÍMITES Y VÍNCULOS',
  items: ['Frases listas para decir que no, responder y poner límites', 'Versiones cálidas, directas y firmes según la situación', 'Respuestas para evitar explicar o pensar de más'],
  result: '“Tengo palabras concretas para manejar mejor estas situaciones.”',
  accent: 'danger'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/wDbjWMvGc2DKaGt8z1iRAf/1.webp',
  alt: 'Página del pack: ¿Estás resolviendo o solo dando otra vuelta?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gxcfYTdQ1bTNquVRqAvH88/2.webp',
  alt: 'Página del pack: Protocolo 01, sigo repitiendo esa conversación.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3pnJ97gBoxLaodhZG3R3L1/3.webp',
  alt: 'Página del pack: Protocolo 06, ya decidí pero sigo revisándolo.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uu6KjWiWaPSXHMWgCvyzB5/4.webp',
  alt: 'Página del pack: Protocolo 08, tres rutas.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'CALMA APLICADA',
  items: ['Tenés 20 secuencias de respuesta rápida ya preparadas', 'Elegís opciones de 3, 5 o 10 minutos según el momento', 'Sabés qué hacer ante saturación, espera, enojo, culpa, anticipación o urgencia'],
  value: '$12.000'
}, {
  number: '02',
  title: 'RUTINA NOCTURNA DE DESCARGA MENTAL',
  items: ['Recibís 10 secuencias preparadas para cerrar el día', 'Ordenás pendientes, conversaciones y preocupaciones sin crear tu propia rutina', 'Marcás un cierre antes de llevarte todos los temas abiertos a la noche'],
  value: '$10.000'
}, {
  number: '03',
  title: 'DECISIONES EN FRÍO',
  items: ['Usás el sistema ROJO → AMARILLO → VERDE antes de actuar por impulso', 'Pasás tus decisiones por filtros claros de urgencia, información y reversibilidad', 'Evitás mandar mensajes o tomar decisiones importantes en plena carga emocional'],
  value: '$9.000'
}, {
  number: '04',
  title: 'BIBLIOTECA DE REENCUADRES Y RESPUESTAS INTERNAS',
  items: ['Tenés 80 respuestas listas para pensamientos automáticos frecuentes', 'Encontrás qué responderte ante culpa, incertidumbre, comparación o necesidad de control', 'Evitás tener que inventar una frase útil justo cuando más saturada estás'],
  value: '$11.000'
}, {
  number: '05',
  title: 'PLAN DE IMPLEMENTACIÓN EMOCIONAL — 21 DÍAS',
  items: ['Seguís una ruta completamente organizada durante 21 días', 'Sabés qué recurso abrir, cuánto tiempo dedicar y cuándo terminar cada jornada', 'Empezás a usar todo el pack sin preguntarte por dónde comenzar'],
  value: '$10.000'
}];
